import { Routes } from '@angular/router';
import { AuthGuard, CanDeactivateGuard } from './components';
import {
  AccessDeniedComponent,
  AfterLoginComponent,
  AfterLogoutComponent,
  ApproveOrderComponent,
  BeforeLoginComponent,
  ContainerAdminComponent,
  ContainerTypeAdminComponent,
  ContainmentTypeAdminComponent,
  GrowthStageAdminComponent,
  InsectAdminComponent,
  InsectaryDashboardComponent,
  InsectPrepComponent,
  LocationAdminComponent,
  LocationTypeAdminComponent,
  LookupListComponent,
  MetricsComponent,
  NoPermissionsComponent,
  OrderDetailsComponent,
  PageNotFoundComponent,
  PermitsListAdminComponent,
  ProjectAdminComponent,
  RequesterDashboardComponent,
  RequesterReceive,
  SecurityAdminComponent,
  SiteCatalogAdminComponent,
  SiteCatalogListComponent,
  SubstrateAdminComponent,
  SubstratePrepComponent,
  UnitOfMeasureAdminComponent,
  VariantTypeAdminComponent,
  VendorAdminComponent,
  VendorOrderComponent
} from './pages';
import { IInsectaPermissions } from './services/app-init.service';
import { PocOrderDetailsComponent } from './pages/poc';

export const routes: Routes = [
  {
    path: 'insectarydashboard',
    component: InsectaryDashboardComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.canViewInsectaryDashboard
    }
  },
  {
    path: 'insectarydashboard/approve',
    component: ApproveOrderComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.insectaryApproveOrders
    }
  },
  {
    path: 'insectarydashboard/vendor',
    component: VendorOrderComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.insectaryVendorOrders
    }
  },
  {
    path: 'insectarydashboard/insectprep',
    component: InsectPrepComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.insectaryInsectPrep
    }
  },
  {
    path: 'insectarydashboard/substrateprep',
    component: SubstratePrepComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.insectarySubstratePrep
    }
  },
  {
    path: 'requesterdashboard',
    component: RequesterDashboardComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.canViewRequestorDashboard || permissions.canViewInsectaryDashboard
    }
  },
  {
    path: 'requesterdashboard/receive',
    component: RequesterReceive,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.canViewRequestorDashboard || permissions.canViewInsectaryDashboard
    }
  },
  {
    path: 'orders/:orderId/:source',
    component: OrderDetailsComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.canViewRequestorDashboard || permissions.canViewInsectaryDashboard
    }
  },
  {
    path: 'admin/globallists',
    component: LookupListComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureAdminGlobalLists
    }
  },
  {
    path: 'admin/containers',
    component: ContainerAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureContainers
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/insects',
    component: InsectAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureInsects
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/locations',
    component: LocationAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureLocations
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/substrates',
    component: SubstrateAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureSubstrates
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/vendors',
    component: VendorAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureVendors
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/containertypes',
    component: ContainerTypeAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureContainerTypes
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/containmenttypes',
    component: ContainmentTypeAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureContainmentTypes
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/growthstages',
    component: GrowthStageAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureGrowthStages
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/locationtypes',
    component: LocationTypeAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureLocationTypes
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/permits',
    component: PermitsListAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configurePermits
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/projects',
    component: ProjectAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureProjects
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/unitsofmeasure',
    component: UnitOfMeasureAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureUnitsOfMeasure
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/varianttypes',
    component: VariantTypeAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureVariantTypes
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/metrics',
    component: MetricsComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.canViewMetrics
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/catalogs',
    component: SiteCatalogListComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureSiteCatalogs
    }
  },
  {
    path: 'admin/sitecatalog/:locationId',
    component: SiteCatalogAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureSiteCatalogs
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/sitecatalog',
    component: SiteCatalogAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureSiteCatalogs
    },
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/security',
    component: SecurityAdminComponent,
    canActivate: [AuthGuard],
    data: {
      roleFunc: (permissions: IInsectaPermissions) => permissions.configureSecurity
    },
    canDeactivate: [CanDeactivateGuard]
  },

  {
    path: 'poc',
    component: PocOrderDetailsComponent
  },

  { path: 'before-login', component: BeforeLoginComponent },
  { path: 'after-login', component: AfterLoginComponent },
  { path: 'after-logout', component: AfterLogoutComponent },
  { path: 'no-permissions', component: NoPermissionsComponent },
  { path: 'access-denied', component: AccessDeniedComponent },
  { path: '404', component: PageNotFoundComponent },
  { path: '', redirectTo: '/before-login', pathMatch: 'full' },
  { path: '**', redirectTo: '/404' }
];
